import React from 'react';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import moment from 'moment';

export default ({
  label, value, onChange,
}) => (
  <LocalizationProvider dateAdapter={AdapterMoment}>
    <TimePicker
      ampm={false}
      ampmInClock={false}
      label={label}
      inputFormat="HH:mm:ss"
      mask=""
      value={value ? moment(value, 'HH:mm:ss', 'de') : null}
      onChange={(e) => onChange(e?.format?.('HH:mm:ss'))}
      views={['hours', 'minutes', 'seconds']}

      renderInput={(params) => <TextField className="MuiFormControl-marginNormal" {...params} />}
      OpenPickerButtonProps={{
        style: { marginRight: '0px' },
      }}
    />
  </LocalizationProvider>
);
